// @flow
import type {
  ValidatedAdvertisementWithStoredMedia,
  ValidatedAdvertisementWithStoredMediaPatch
} from '../../../components/types'
import _ from 'lodash'

type PutAction = {|
  +type: 'ADS.PUT',
  +storeId: string,
  +advertisement: ValidatedAdvertisementWithStoredMedia
|}

type PatchAction = {|
  +type: 'ADS.PATCH',
  +storeId: string,
  +diff: ValidatedAdvertisementWithStoredMediaPatch
|}

type MediaRemoveAction = {|
  +type: 'ADS.MEDIA_REMOVE',
  +storeId: string
|}

type Action = PutAction | PatchAction | MediaRemoveAction

export type { PutAction, PatchAction, MediaRemoveAction, Action }

type State = { [string]: ValidatedAdvertisementWithStoredMedia }

export type { State }

export function put(
  storeId: string,
  advertisement: ValidatedAdvertisementWithStoredMedia
): PutAction {
  return {
    type: 'ADS.PUT',
    storeId,
    advertisement
  }
}

export function patch(
  storeId: string,
  diff: ValidatedAdvertisementWithStoredMediaPatch
): PatchAction {
  return {
    type: 'ADS.PATCH',
    storeId,
    diff
  }
}

export function mediaRemove(storeId: string): MediaRemoveAction {
  return {
    type: 'ADS.MEDIA_REMOVE',
    storeId
  }
}

const initialState: State = {}

const emptyCommonMedia = {
  fbImageCrop: null,
  fbInstagramImageCrop: null,
  fbInstagramImageErrors: [],
  fbInstagramImageStoreId: null,
  fbStoriesImageCrop: null,
  fbStoriesImageErrors: [],
  fbStoriesImageStoreId: null,
  fbThumbnailImageCrop: null,
  fbThumbnailImageErrors: [],
  fbThumbnailImageStoreId: null,
  glImageCrop: null,
  multiImageErrors: [],
  multiImageStoreId: null,
  tmColumnCrop: null,
  tmMultiCrop: null,
  tmSmallImageCrop: null,
  tmSmallImageErrors: [],
  tmSmallImageStoreId: null,
  videoErrors: [],
  videoStoreId: null,
  vkArticleCrop: null,
  vkBigImageErrors: [],
  vkBigImageStoreId: null,
  vkColumnCrop: null,
  vkMultiCrop: null,
  vkSiteCrop: null
}

export const emptyAd: ValidatedAdvertisementWithStoredMedia = {
  advertisementTemplateId: null,
  carouselStoreId: null,
  columnDescription: '',
  columnDescriptionErrors: [],
  columnImageErrors: [],
  columnImageStoreId: '',
  fbLinkButton: '',
  fbLinkButtonErrors: [],
  fbMultiDescription: '',
  fbMultiDescriptionErrors: [],
  fbTitle: '',
  fbTitleErrors: [],
  fbUrl: '',
  fbUrlErrors: [],
  id: null,
  logoImageCrop: null,
  logoImageErrors: [],
  logoImageStoreId: null,
  multiDescription: '',
  multiDescriptionErrors: [],
  productDescription: '',
  productDescriptionErrors: [],
  productTitle: '',
  productTitleErrors: [],
  snippetImageCrop: null,
  snippetImageErrors: [],
  snippetImageStoreId: null,
  title: '',
  titleErrors: [],
  tmCarouselDescription: '',
  tmCarouselDescriptionErrors: [],
  tmColumnCrop: null,
  tmLinkButton: '',
  tmLinkButtonErrors: [],
  tmMultiCrop: null,
  tmUrl: '',
  tmUrlErrors: [],
  url: '',
  urlErrors: [],
  vkArticleCrop: null,
  vkColumnCrop: null,
  vkLinkButton: '',
  vkLinkButtonErrors: [],
  vkLinkTitle: '',
  vkLinkTitleErrors: [],
  vkMultiCrop: null,
  vkMultiDescription: '',
  vkMultiDescriptionErrors: [],
  vkSiteCrop: null,
  vkTitle: '',
  vkTitleErrors: [],
  vkUrl: '',
  vkUrlErrors: [],
  vkWithoutButtonDescription: '',
  vkWithoutButtonDescriptionErrors: [],
  ...emptyCommonMedia
}

function adWithEmptyMedia(
  advertisement: ValidatedAdvertisementWithStoredMedia
): ValidatedAdvertisementWithStoredMedia {
  return { ..._.cloneDeep(advertisement), ...emptyCommonMedia }
}

export default function advertisements(state: State = initialState, action: Action) {
  switch (action.type) {
    case 'ADS.PUT':
      return { ...state, [action.storeId]: action.advertisement }
    case 'ADS.PATCH':
      return { ...state, [action.storeId]: { ...(state[action.storeId] || {}), ...action.diff } }
    case 'ADS.MEDIA_REMOVE':
      return { ...state, [action.storeId]: adWithEmptyMedia(state[action.storeId]) }
    default:
      return state
  }
}
